import React, { useEffect, useState } from 'react';

import Button from '@components/uikit/Button/Button';
import Input from '@components/uikit/Input/Input';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import type { ILanguage } from '../../model/languagesList';
import type { ITranslate, ITranslateSourceData, TSourceData } from '../../model/translateSourceDataList';
import { useSaveTranslationMutation } from '../../services/useSaveTranslationMutation';
import style from './style.module.scss';

interface IProps {
  language: ILanguage;
  translation?: ITranslate;
  translateSourceData: ITranslateSourceData;
  type: TSourceData;
  isLoading: boolean;
}

const TranslationsInput: React.FC<IProps> = ({
  language,
  translation,
  translateSourceData,
  type,
  isLoading,
}) => {
  const { t } = useTranslation();
  const { mutate: saveTranslationMutate } = useSaveTranslationMutation(type);
  const initialTranslation = translation?.text || '';

  const [translationText, setTranslationText] = useState(initialTranslation);

  const isDirty = translationText !== initialTranslation;

  const handleSave = () => {
    saveTranslationMutate(
      {
        id: translateSourceData.id,
        type: translateSourceData.type,
        field: translateSourceData.rowName,
        translation: {
          [language.id]: translationText,
        },
      },
      {
        onSuccess: ({ data }) => {
          if (data?.status !== 'error') {
            showToast({ variant: 'success', message: t('Your changes have been saved.') });
          } else {
            showToast({ variant: 'error', message: t(data?.errors.name || 'Something went wrong!') });
          }
        },
      },
    );
  };

  const handleReset = () => {
    setTranslationText(initialTranslation);
  };

  return (
    <div className={style.translateInputWrapper}>
      <div className={style.leftSideWrapper}>
        <Input
          placeholder={t('Enter translation')}
          type="woHelperText"
          value={translationText}
          onChange={(event) => setTranslationText(event.target.value)}
        />
      </div>
      <div className={style.rightSideWrapper}>
        {isDirty && (
          <div className={style.actionsBlock}>
            <Button text={t('Reset')} type="secondary" onClick={handleReset} disabled={isLoading} />
            <span className={style.separator} />
            <Button text={t('Save')} type="secondary" onClick={handleSave} disabled={isLoading} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TranslationsInput;
